import { useState, useEffect } from "react";
import { listStatusOrder } from '../customer/constant/CustomerBirthday';
import * as convert from "../constant/Convert.helper";
import Avatar from 'react-avatar';
import {orderStatusClass } from '../orders/constant/OrderConstant';

function getEmployeeService(val, key) {
    let listName = [];
    for (let i = 1; i < 5; i++) {
        if (val['employee_'+ key +'_name'+i]) listName.push(val['employee_'+ key +'_name'+i])
    }

    return listName.join(", ");
}

function convertDateTime(event) {
    let date = new Date(event),
        month = date.getMonth() + 1,
        day = date.getDate(),
        hours = date.getHours(),
        minus = date.getMinutes();
    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;    
    if (hours < 10) hours = '0' + hours;
    if (minus < 10) minus = '0' + minus;
    let text = day + '-' + month + '-' + date.getFullYear();
    text = text + ' ' + hours + ':' + minus;
    return text
};

export function CustomerOrderPopup({ orderDetail }) {
    const [isCopyText, setIsCopyText] = useState('')
    const [userAdmin, setUserAdmin] = useState(JSON.parse(localStorage.getItem("user_info")))      

    useEffect(() => {
        setUserAdmin(JSON.parse(localStorage.getItem("user_info")))
    }, [])

    const copyText = (text) => {
      setIsCopyText('isCopy')
      navigator.clipboard.writeText(text)
      setTimeout(() => {
        setIsCopyText('')
      }, 1000);
    }

    return (
        <>
            <div className="head-popup">
                <div className="title">Chi tiết đơn hàng</div>
                <div className="order-status">
                    Trạng thái:
                    <span className={orderStatusClass[orderDetail.status]} >{listStatusOrder[orderDetail.status]}</span>
                </div>
            </div>
            <div className="body-popup">
                <div className="row">
                    <div className="col-12">
                        <div className="customer">
                            <div className="customer-avatar">
                                {orderDetail.customers.avatar_url ?
                                    <img src={orderDetail.customers.avatar_url} alt="" />
                                    : <Avatar name={orderDetail.customers.full_name} size="60" textSizeRatio={1.75} round="50%" />}

                                <div className="info-customer">
                                    <p>{orderDetail.customers.full_name}{orderDetail.customers.identifier === 1 ? <span className="identifier-customer"><img src="/icons/verified.png" /></span> : ""}</p>
                                    <p>{orderDetail.customers.mobile}</p>
                                </div>
                            </div>
                            <div className="order-status">Mã HD:
                                <span className={orderStatusClass[orderDetail.status]}>#{orderDetail.order_code}</span>
                                {orderDetail.parent_order_id && orderDetail.type == 3 ? 
                                    <p>Up/Down:<span style={{background: '#8BC34A'}}>HD{orderDetail.parent_order_id} </span></p>
                                : null}
                            </div>
                        </div>
                        <div className="order-info">
                            <p>Đặt lịch từ: <span>{orderDetail.source_from}</span></p>
                            <div className="user-order-customer posion-wraper">
                                <div className="user-title">
                                    <div className="d-inline-block w-100">
                                        <div className="pull-left name-user">Người lập: <span>{orderDetail.User ? orderDetail.User.name : orderDetail.created_name }</span></div>
                                        <div className="pull-right user-order-date">{convertDateTime(orderDetail.created_at)}</div>
                                    </div>
                                    <div className="d-inline-block w-100">
                                        <div className="pull-left name-user">Chỉnh sửa lần cuối: <span>{orderDetail.updatedBy ? orderDetail.updatedBy.name : orderDetail.created_name}</span></div>
                                        <div className="pull-right user-order-date">{convertDateTime(orderDetail.updated_at)}</div>
                                    </div>
                                    <div className="d-inline-block w-100">
                                        <div className="pull-left name-user">Hoàn thành bởi: <span>{orderDetail.updatedBy ? orderDetail.updatedBy.name : orderDetail.created_name}</span></div>
                                        <div className="pull-right user-order-date">{convertDateTime(orderDetail.updated_at)}</div>
                                    </div>
                                    <div className="d-inline-block w-100">
                                        <div className="pull-left name-user">Tại cơ sở: <span>{orderDetail.stores.name_store}</span></div>
                                        {orderDetail.customer_confirm ? 
                                            <div className="pull-right user-order-date">{convertDateTime(orderDetail.customer_confirm)}</div>
                                        :null}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table-list-order-item">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Dịch vụ</th>
                                        <th>Số lượng</th>
                                        <th>Giá</th>
                                        <th>Thành tiền</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderDetail.orderItem.length > 0 ?
                                        orderDetail.orderItem.map((val, key) => (
                                            <tr key={key} className="order-item-tr">
                                                <td>
                                                    <div className="order-item-detail">
                                                        <div className="item-avatar">
                                                            <img src="https://placehold.co/90x90"/>
                                                            <div className="info-service">
                                                                <p>
                                                                    {!orderDetail?.isDeposit ?
                                                                        !val.new_package && val.price == 0 ? 'Sử dụng '
                                                                        : orderDetail?.type == 4 ? "Nâng cấp " 
                                                                        : 'Mua '
                                                                    :null} 
                                                                    {`${val.product ? val.product.product_name : val.product_name}`} 
                                                                </p>
                                                                <p>{val.package_code ?? val.product_code}</p>
                                                                <p>{`Đã làm: ${val.package.count_used} buổi`}</p>
                                                            </div>
                                                        </div>
                                                        <div className="employee-order">
                                                            {getEmployeeService(val, "service") ?
                                                                <p>Nhân viên phục vụ: {getEmployeeService(val, "service")}</p>
                                                            : null}
                                                            {getEmployeeService(val, "consultant") && userAdmin.role != 2 ?
                                                                <p>Tư vấn: {getEmployeeService(val, "consultant")}</p>
                                                            : null}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{val.quantity}</td>
                                                <td className="cl-green">{convert.convertCurrency(val.price ?? 0)}</td>
                                                <td className="cl-green cl-bold">
                                                    {convert.convertCurrency(val.quantity ? val.price * val.quantity - val.discount : 0)} 

                                                    {val.discount && val.discount != 0 ? 
                                                        <p className="discount" style={{textDecoration: "line-through", color: "#777", fontSize: "10px", fontStyle: 'italic'}}>
                                                            {convert.convertCurrency(val.price * val.quantity)}
                                                        </p>
                                                    : null} 
                                                </td>
                                            </tr>
                                        )) 
                                    : null}
                                </tbody>
                            </table>
                        </div>

                        <div className="order-into-money">

                            <div className="user-order-customer  posion-wraper ">
                                <div className="order-price-type">
                                    <p>Thành tiền</p>
                                    <p className="cl-red">Đã thanh toán</p>
                                    <p className= {orderDetail.isDeposit ? "cl-green2"  : "cl-red"}>{orderDetail.isDeposit ? "Quà tặng thẻ tiền" : "Thẻ giảm giá/Voucher"}</p>
                                </div>
                                <div className="list-order-price left-view">
                                    <p className="cl-green2">{convert.convertCurrency(orderDetail.total_price_before ?? 0)}</p>
                                    <p className="cl-red">{convert.convertCurrency(orderDetail.paid_amount_before ?? 0)}</p>
                                    <p className={orderDetail.isDeposit ? "cl-green"  : "cl-red"}>{convert.convertCurrency(orderDetail.discount_by_rule ?? 0)}</p>
                                </div>
                            </div>

                        </div>

                        <div className="order-total-money">
                            <div className="user-order-customer  posion-wraper ">
                                <div className="order-price-type">
                                    <p>Tổng tiền</p>
                                    <p>Tiền khách hàng đưa</p>
                                    {orderDetail.money_owed > 0 ? 
                                        <p className="cl-red">Còn nợ</p>
                                    : null}

                                   {orderDetail.transaction ?
                                        orderDetail.transaction.map((valTrs, keyTrs) => (
                                            (!valTrs.soft_delete) ? 
                                                <p key={keyTrs}>{valTrs.pay_type} {valTrs.status == 2 ? <span style={{color: 'red'}}>*</span> : ""}</p>
                                            : null
                                        ))
                                     : null}
                                </div>
                                <div className="list-order-price left-view">
                                    <p className="cl-green">{convert.convertCurrency(orderDetail.total_price ?? 0)}</p>

                                    <p className="cl-green">
                                        {convert.convertCurrency(orderDetail.payByOther ? Number(orderDetail.payByOther) : 0)}
                                    </p>
                                    {orderDetail.money_owed > 0 ? 
                                        <p className="cl-red blink_me">
                                            {convert.convertCurrency(orderDetail.money_owed)}
                                        </p> 
                                    : null}

                                   {orderDetail.transaction ?
                                        orderDetail.transaction.map((valTrs, keyTrs) => (
                                            (!valTrs.soft_delete) ? 
                                                <p className="cl-green" key={keyTrs}>{convert.convertCurrency(valTrs.paid_amount)}</p>
                                            :null
                                        ))
                                    : null}
                                </div>
                            </div>
                            {orderDetail.description ?
                                <div className="note-order">
                                    <p className="node-title">Ghi chú</p>
                                    <p className="node-text">{orderDetail.description}</p>
                                </div>
                            : null}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}